import { FaFacebookF } from '@react-icons/all-files/fa/FaFacebookF';
import { FaTwitter } from '@react-icons/all-files/fa/FaTwitter';
import { GrLinkedinOption } from '@react-icons/all-files/gr/GrLinkedinOption';
import { IoIosArrowForward } from '@react-icons/all-files/io/IoIosArrowForward';
import { SiDiscord } from '@react-icons/all-files/si/SiDiscord';
import Link from 'next/link';
import { StyledFooter } from './footer.styles';

// @ts-ignore
import apps from 'apps.json';
// @ts-ignore
import posts from 'posts.json';

export const Footer = ({ isDark = false }: { isDark: boolean }) => {
	const currentYear = new Date().getFullYear();

	return (
		<StyledFooter className={isDark ? 'dark' : ''}>
			<div className="content-wrapper">
				<div className="top">
					<div className="column">
						<h2>Website</h2>
						<Link href={'https://www.commoninja.com/'}>Homepage</Link>
						<Link href={'https://www.commoninja.com/pricing'}>Pricing</Link>
						<Link href={'https://www.commoninja.com/widgets'}>Our Widgets</Link>
						<Link href={'https://www.commoninja.com/platforms'}>
							Supported Platforms
						</Link>
						<Link href={'/'}>Search Engine</Link>
						<Link href={'https://www.commoninja.com/platform/'}>
							Developers
						</Link>
					</div>
					<div className="column">
						<h2>Widgets</h2>
						{apps.slice(0, 6).map((app: any) => (
							<Link
								key={app.slug}
								href={`https://www.commoninja.com/widgets/${app.slug}?via=discover`}
							>
								{app.name}
							</Link>
						))}
						<Link className="blue" href={'https://www.commoninja.com/widgets'}>
							See All Widgets
							<IoIosArrowForward className="icon" />
						</Link>
					</div>
					<div className="column">
						<h2>Resources</h2>
						<Link href={'https://www.commoninja.com/blog'} target="_blank">
							Blog
						</Link>
						<Link href={'https://help.commoninja.com/hc/en-us'} target="_blank">
							Help Center
						</Link>
						<Link href={'https://www.commoninja.com/affiliates'}>
							Affiliate Program
						</Link>
						<Link
							href={
								'https://help.commoninja.com/hc/en-us/community/topics/360000419377-General-Discussion'
							}
							target="_blank"
						>
							Community Forum
						</Link>
						<Link
							href={
								'https://help.commoninja.com/hc/en-us/community/topics/360000419337-Feature-Requests'
							}
							target="_blank"
						>
							Feature Requests
						</Link>
						<Link href={'https://www.commoninja.com/write-for-us'}>
							Write for Us
						</Link>
						<Link
							href={'https://www.commoninja.com/contact-us'}
							target="_blank"
						>
							Contact Us
						</Link>
					</div>
					<div className="column">
						<h2>Follow Us</h2>
						<Link
							href={'https://www.facebook.com/CommonNinja/'}
							target="_blank"
						>
							<FaFacebookF className="icon" />
							Facebook
						</Link>
						<Link href={'https://twitter.com/commonninja'} target="_blank">
							<FaTwitter className="icon" />
							Twitter
						</Link>
						<Link
							href={'https://www.linkedin.com/company/common-ninja'}
							target="_blank"
						>
							<GrLinkedinOption className="icon" />
							LinkedIn
						</Link>
						<Link
							href={'https://discord.com/invite/cxqUTbvMNd'}
							target="_blank"
						>
							<SiDiscord className="icon" />
							Discord
						</Link>
					</div>
					<div className="column blog-posts">
						<h2>Blog</h2>
						{posts.map((post: any) => (
							<Link
								key={post.slug}
								href={`https://www.commoninja.com/blog/${post.slug}`}
							>
								{post.name}
							</Link>
						))}
						<Link className="blue" href={'https://www.commoninja.com/blog'}>
							See All Blog Posts
							<IoIosArrowForward className="icon" />
						</Link>
					</div>
				</div>
				<div className="bottom">
					<small>
						© Copyright 2012-{currentYear}, Common Ninja. All rights reserved.
					</small>
					<div className="bottom-links">
						<Link href={'https://www.commoninja.com/terms'}>
							Terms & Conditions
						</Link>
						<Link href={'https://www.commoninja.com/privacy'}>
							Privacy Policy
						</Link>
					</div>
				</div>
			</div>
		</StyledFooter>
	);
};
